<template>
  <div class="aside-container">
    <div class="paper-left">
      <!-- 试卷信息头部 -->
      <div class="paper-header">
        <p class="paper-name">{{ parperArr.name }}</p>
        <div class="paper-des">
          <div class="des-item">
            <i class="el-icon-trophy"></i>
            <span>总分: {{ parperArr.score }}</span>
          </div>
          <div class="des-item">
            <i class="el-icon-time"></i>
            <span>时长: {{ parperArr.suggestTime }}分钟</span>
          </div>
        </div>
      </div>

      <el-divider></el-divider>

      <!-- 题目导航区域 -->
      <div class="question-nav">
        <div v-for="(item,index) in allQuestionArr" :key="index" class="question-group">
          <el-tooltip class="item" :content="item.name" placement="top" effect="light" :disabled="item.name.length <= 10">
            <div class="question-type-title">
              <span class="title-dot"></span>
              <span class="title-text">{{ item.name }}</span>
            </div>
          </el-tooltip>
          <div class="question-buttons">
            <a @click="clickanchor(`#q${item2}`)" v-for="item2 in item.questionOrder" :key="item2">
              <el-button size="mini" type="infor" class="subjetButton2">
                {{ item2 }}
              </el-button>
            </a>
          </div>
        </div>
      </div>

      <el-divider></el-divider>

      <!-- 操作区域 -->
      <div class="action-area">
        <div class="button-group">
          <el-button type="primary" @click="back()" class="action-btn">
            <i class="el-icon-back"></i> 退出
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        props: {
            parperArr: {
                type: Object,
                default: () => ({})
            },
            allNumberArr: {
                type: Array,
                default: () => []
            },
            errorArr: {
                type: Array,
                default: () => []
            },
            allQuestionArr: {
                type: Array,
                default: () => []
            }
        },
        watch: {
            errorArr: {
                handler: function (n, o) {
                    let idArr = [];
                    this.errorArr.forEach(item => {
                        idArr.push(item)
                    })
                    this.$nextTick(() => {
                        // let buttonArr2 = document.getElementsByClassName("subjetButton2");
                        const elements = this.$el.getElementsByClassName('subjetButton2');
                        const elementsArray = Array.from(elements);
                        elementsArray.forEach(item => {
                            let innerHTMLValue = item.getElementsByTagName("span")[0].innerHTML;
                            if (idArr.indexOf(parseInt(innerHTMLValue)) != -1) {
                                item.classList.remove("el-button--infor"); // 设置
                                item.classList.remove("el-button--success");
                                item.classList.add("el-button--danger"); // 设置
                            } else {
                                item.classList.remove("el-button--danger"); // 设置
                                item.classList.remove("el-button--success");
                                item.classList.add("el-button--infor"); // 设置
                            }
                        })
                    })
                },
                deep: true
            },
        },
        methods: {
            clickanchor(idName) {
                this.$emit("changeMaodian", idName);
                // document.querySelector(idName).scrollIntoView({
                // 	behavior: "smooth"
                // });
            },
            back() {
                // this.$router.go(-1)
                window.close()
            },
        },

        data() {
            return {
            }
        }
    }
</script>

<style lang="scss" scoped>
// 主容器
.aside-container {
  height: 100%;
}

// 分隔线样式
::v-deep .el-divider--horizontal {
  margin: 16px 0;
  background-color: #ebeef5;
}

// 左侧面板主体
.paper-left {
  width: 280px;
  color: #333;
  padding: 20px 16px;
  background: #fff;
}

// 试卷信息头部
.paper-header {
  padding-bottom: 5px;

  .paper-name {
    font-size: 16px;
    color: #303133;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 14px;
    line-height: 1.4;
  }

  .paper-des {
    display: flex;
    justify-content: flex-start;
    gap: 24px;

    .des-item {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 13px;
      color: #606266;

      i {
        font-size: 14px;
        color: #909399;
      }
    }
  }
}

// 题目导航区域
.question-nav {
  // 移除高度限制，让内容完全显示
}

.question-group {
  margin-bottom: 16px;
}

.question-type-title {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  margin-bottom: 10px;
  cursor: pointer;

  .title-dot {
    width: 3px;
    height: 12px;
    background: #409eff;
    border-radius: 1px;
    margin-right: 8px;
    flex-shrink: 0;
  }

  .title-text {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.question-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 2px 0;

  > a {
    width: calc((100% - 32px) / 5);
    display: block;
    text-decoration: none;
  }
}

// 题目按钮样式
.subjetButton2 {
  width: 100%;
  height: 36px;
  min-width: 0;
  padding: 0;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
  border: 1px solid #dcdfe6;
  background: #fff;
  color: #606266;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;

  ::v-deep span {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &:hover {
    cursor: pointer;
    border-color: #409eff;
    color: #409eff;
  }
}

// 错题按钮样式
::v-deep .el-button--danger {
  background: #f56c6c !important;
  border-color: #f56c6c !important;
  color: #fff !important;

  &:hover {
    background: #f78989 !important;
    border-color: #f78989 !important;
  }
}

// 操作区域
.action-area {
  margin-top: 5px;
}

.button-group {
  display: flex;
  justify-content: center;
  gap: 12px;
}

.action-btn {
  padding: 9px 15px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 400;
  transition: all 0.2s;

  i {
    margin-right: 4px;
  }

  &:hover {
    background: #66b1ff;
    border-color: #66b1ff;
  }
}

</style>
